/** Helpers de détection mode de paiement (noms seedés côté API). */

export function isMobileMoneyMethod(name?: string | null): boolean {
  return (name ?? '').toLowerCase().includes('mobile');
}

export function isCashMethod(name?: string | null): boolean {
  const n = (name ?? '').toLowerCase();
  return n.includes('espèce') || n.includes('espece') || n.includes('cash');
}
